export default __webpack_public_path__ + "static/consultingandaudit-08672927adf9f1df420159fd0cae7433.png";